<template>
    <div class="share">
        <div class="title">分享</div>
        <ul>
            <li class="weixin">
                <a href="javascript:void(0)" ref="wxRef">
                    <em class="icon weixin-icon"></em><span class="label">微信分享</span>
                </a>
                <div class="wx-code">
                    <div class="cort"></div>
                    <div class="code-pic">
                        <div id="qrcode" class="qrcode"></div>
                    </div>
                </div>
            </li>
            <li class="sinat">
                <a data-clev="10220259" target="_blank" :href="sina_url" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:weibo">
                    <em class="icon sinat-icon"></em>
                    <span class="label">新浪微博</span>
                </a>
            </li>
            <li class="qzone">
                <a data-clev="10220260" target="_blank" :href="qzone_url" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:qqz">
                    <em class="icon qzone-icon"></em>
                    <span class="label"></span>QQ空间
                </a>
            </li>
            <li class="copy-link" @click="copy" @mouseenter.once="copy">
                <a href="javascript:void(0)" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:link">
                    <em class="icon link-icon"></em><span class="label">复制链接</span>
                </a>
            </li>
        </ul>
        <div class="toast" v-show="showToast">
            <div class="toast-text">链接复制成功</div>
        </div>
        <!-- 扫码打开 -->
        <div class="phone-scan">
            <div class="qr-image" id="browseInPhone">
                <div class="sohu-logo"></div>
            </div>
            <div class="text1">
                <span>扫码打开</span>
                <span class="border-font">手机搜狐网</span>
            </div>
            <div class="text2">
                <div>无需下载APP</div>
                <div>精彩内容随时看</div>
            </div>
        </div>
    </div>
</template>
<script>
import Utils from "@/utils/Utils"
import QRCode from 'qrcodejs2'
import { env } from '@/env'
import { addQueryArgs } from '@/utils/url-utils'
import { acodeConfig } from '@/config/spmConfig'

export default {
    components: {
    },
    data() {
        return {
            url: window.location.href,
            title: '',
            pic: '',
            qzone_url: '',
            sina_url: '',
            showToast: false,
            qrcodeUrl: '',
            shareAction: acodeConfig.shareAction
        }
    },
    mounted() {
        const articleinfo = window?.pcArticleInfo
        this.pic = document.querySelector('article img')?.src || ''
        this.title = articleinfo?.title
        this.qrcodeUrl = '/a/' + articleinfo?.news_id + '_' + articleinfo?.media_id
        this.sina_url = "http://service.weibo.com/share/share.php?url=" + encodeURIComponent(this.url) + "&title=" + encodeURIComponent(this.title) + "&searchPic=true&pic=" + this.pic+"&appkey=2890110694";
        this.getQzoneUrl()
        this.renderCode()
        this.initQRCode()
    },
    methods: {
        getQzoneUrl() {
            let prod_qzone_url = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + encodeURIComponent(this.url);
            let test_qzone_url = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + encodeURIComponent(this.url) + "&title=" + encodeURIComponent(this.title) + "&searchPic=true&pics=" + this.pic + "?imageView&thumbnail=550x0&desc=";
            this.qzone_url = env == 'prod' ? prod_qzone_url : test_qzone_url
        },
        copy() {
            import(/* webpackChunkName: "clipboard" */'clipboard').then((Clipboard)=>{
                let copylink = Utils.getWapSohuHost() + this.qrcodeUrl + '?_trans_=010004_pcwzy';

                var clipboard = new Clipboard.default('.copy-link', {
                    text: () => window?.pcArticleInfo?.title + " - 搜狐网" + "\n" + copylink
                });
                clipboard.on('success', () => {
                    this.showToast = true
                    var timer = setTimeout(() => {
                        this.showToast = false
                        clearTimeout(timer)
                    }, 2000)
                    clipboard.destroy(); // 复制成功后销毁实例
                });
                clipboard.on('error', () => {
                    console.error('复制链接失败');
                    clipboard.destroy(); // 复制失败后销毁实例
                });
            })
        },
        renderCode() {
            this.$refs['wxRef']?.addEventListener('mouseenter',()=>{
                window?.sohuSpm?.sendAction({
                     acode: acodeConfig.shareAction,
                     clkParam: 'shareCode:wxf'
                })
            })
            new QRCode(document.querySelector('.qrcode'), {
                text: Utils.getWapSohuHost() + this.qrcodeUrl, // 需要转换为二维码的内容
                width: 84,
                height: 84,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },
        // 初始化二维码
        initQRCode(){
            const anchorDom = document.getElementById("browseInPhone")
            const pathname = window.location.pathname
            const wapHostMap = {
                test: 'https://d2.m.sohu.com',
                pre: 'https://t3.m.sohu.com',
                prod: 'https://m.sohu.com',
            }
            const origin = wapHostMap[env] || wapHostMap.prod
            const url = origin + pathname
            const data = addQueryArgs(url, {
                "_trans_": "060005_pcsywzyewmdl"
            })
            new QRCode(anchorDom, {
                text: data,
                width: 80,
                height: 80,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H,
            })
        },
    }
}
</script>
<style lang="less" scoped>
.share{position: relative; margin-top: 30px; padding-top:20px; border-top:1px #EFEFEF solid;}
.share li{margin-bottom: 20px;}
.share li a{color:#606060;}
.share li:hover a{color: #303030;}
.share li .icon{margin-right:8px;width:20px;height:20px;opacity: 0.8;}
.share li:hover .icon{opacity: 1;}
.share li .sinat-icon{background:url(../images/share_weibo.png) no-repeat 0 0;}
.share li .weixin-icon{background:url(../images/share_wechat.png) no-repeat 0 0;}
.share li .qzone-icon{background:url(../images/share_qzone.png) no-repeat 0 0;}
.share li .link-icon{background:url(../images/share_copy_link.png) no-repeat 0 0;}
.share li .icon:hover{opacity:1;}
.share li a{box-sizing:border-box;display: block;line-height: 20px;text-align: left;padding-left: 22px;}
.share .weixin{position:relative;}
.share .weixin:hover .wx-code{display: block;}
.share .wx-code{display:none;position:absolute;width:140px;height:120px;text-align:center;bottom:17px;transition: opacity ease-in-out .5s;}
.share .wx-code .cort{display:none;}
.share .wx-code .qrcode {box-sizing:border-box;margin:0 auto;width: 116px;height:120px;background:url(../images/bg_wechat_qrcode.png) no-repeat 0 0;padding: 15px 16px 21px;}
.share .wx-code p{font-size:14px;line-height:20px;color:#191919;}
.share .toast {
    position: fixed;
    width: 1180px;
    margin: 0 auto;
    z-index: 999;
    top: 80px;
    .toast-text {
        margin-left:190px;
        width: 600px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #ffffff;
        color: #303030;
        box-shadow: 3px 3px 10px rgba(0,0,0,.12);
    }
}
.share .phone-scan{
    margin: 4px 16px 0px 16px;
    overflow: hidden;
    width: 108px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    .qr-image{
        width: 88px;
        height: 88px;
        position: relative;
        background-color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        .sohu-logo{
            width: 20px;
            height: 20px;
            background-color: #FFD100;
            border-radius: 3px;
            background-image: url('../images/icon_logo.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: 14px 14px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate3d(-50%,-50%,0);
        }
    }
    .main-title{
        font-size: 0px;
    }
    .text1{
        margin-top: 4px;
        height: 17px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #111111;
        line-height: 17px;
        text-align: justify;
        font-style: normal;
        display: inline-flex;
    }
    .border-font{
        font-weight: 600;
    }
    .text2{
        margin-top: 4px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 14px;
        text-align: center;
        font-style: normal;
        display: block;
    }
}
</style>